import constants, { encryptedMarketplaceId } from '@/constants';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { onBeforeMount, onMounted, ref } from 'vue';
/**
 * Use style in the component
 * 1.@/assets/styles/['en','cn'...]
 * 2.Based on the directory structure in src, create an identical one
 * @param {string} path
 */
export const useLess = path => {
  const fileName = constants.marketPlaceStyleMap[encryptedMarketplaceId];
  require(`@/assets/styles/${fileName}/${path}`);
};

export const useRecordLoadingEvent = callBack => {
  const beforeMountTime = ref();
  const mountedTime = ref();
  const duration = ref();
  onBeforeMount(() => {
    beforeMountTime.value = new Date().getTime();
  });
  onMounted(() => {
    mountedTime.value = new Date().getTime();
    duration.value = mountedTime.value - beforeMountTime.value;
    awsRumHandler.recordLoadingEvent(callBack(duration.value));
  });
};
